"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _startcase = require('lodash.startcase');

var STATUS_MAP = new Map([['PENDING_MASTER', 'Submitted'], ['APPROVED', 'Project Complete']]);

var formatStatuses = function formatStatuses(statuses) {
  var formatted = statuses.map(function (name) {
    if (STATUS_MAP.has(name)) {
      return STATUS_MAP.get(name) || name;
    }

    return _startcase(name.toLowerCase());
  });
  return formatted;
};

var _default = formatStatuses;
exports.default = _default;